<template>
  <div class="alert"
      :class="{
        'alert-danger': type === 'danger',
        'alert-success': type === 'success',
        'alert-warn': type === 'warn'
      }"
      v-if="show">
    <div class="message" v-html="message"></div>
    <div class="close-wrapper" @click="close">
      <icon type="close" class="icon-close"></icon>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import Icon from '@/components/icon'

  export default {
    name: 'alert',

    components: {
      Icon
    },

    computed: {
      ...mapState('alert', [
        'show',
        'message',
        'type'
      ])
    },

    methods: {
      close() {
        this.$store.dispatch('alert/remove')
      }
    }
  }
</script>

<style lang="scss" scoped>
  .alert {
    position: relative;
    z-index: $z-index--alert;
    text-align: center;
    color: hsla(0, 0%, 96%, 1);
    padding: 8px 22px;
    font-size: 15px;
    line-height: 15px;
    border-bottom: 1px solid transparent;
    display: flex;
  }

  .alert-danger {
    background-color: $alert-bg;
    border-color: $alert-border;
  }

  .alert-warn {
    background-color: color(yellow, light);
    border-color: color(yellow);
    color: color(yellow, darker);
    .icon-close {
      fill: color(yellow, darker);
    }
    & /deep/a {
      color: color(blue, dark);
      transition: color 100ms linear;
      &:hover {
        color: color(blue);
      }
    }
  }

  .alert-success {
    background-color: $alert-success-bg;
    border-color: $alert-success-border;
  }

  .message {
    flex: 1;
  }

  .close-wrapper {
    @extend %clickable;
    transition: transform 850ms $ease-out-circ;
    display: flex;
    align-items: center;
    justify-content: center;
    &:hover {
      transform: rotate(180deg);
    }
  }

  .icon-close {
    width: 14px;
    height: 14px;
    fill: hsla(0, 0%, 100%, 1);
  }
</style>



// WEBPACK FOOTER //
// src/components/alert.vue